import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../api";
import { Bounce, toast } from "react-toastify";
import Table from "../Table/Table";
import PopUp from "../PopUp";

const EsperienzeLavorative = () => {
  const { codiceFiscale } = useParams();
  const [esperienze, setEsperienze] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [showPopUp, setShowPopUp] = useState(false);
  const [selectedEsperienzeId, setSelectedEsperienzeId] = useState(null);

  const fetchEsperienze = async () => {
    setLoading(true);
    try {
      const response = await api.get("/esperienze-lavorative", {
        params: { trainerId: codiceFiscale },
      });

      const flattened = response.data.map((e) => ({
        ...e,
        nomeMansione: e.mansione?.nomeMansione || "-",
        descrizioneMansione: e.mansione?.descrizioneMansione || "-",
        dal: formatDate(e.dal),
        al: formatDate(e.al),
      }));

      setEsperienze(flattened);
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");
    if (userRole !== "TRAINER") {
      alert("Accedi come docente per visualizzare le esperienze lavorative!");

      navigate("/login");
      localStorage.clear();
    } else {
      fetchEsperienze();
    }
  }, [navigate]);

  const handleDelete = async () => {
    if (!selectedEsperienzeId) {
      return;
    }
    try {
      setLoading(true);
      const response = await api.delete(
        `/esperienze-lavorative/${selectedEsperienzeId}`
      );
      if (response.status === 204) {
        toast.success("Esperienza eliminata con successo!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        fetchEsperienze();
      } else {
        toast.error("Errore durante l'eliminazione dell'esperienza!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
      setSelectedEsperienzeId(null);
      setShowPopUp(false);
    }
  };

  const columns = [
    { field: "ruolo", header: "Ruolo" },
    { field: "nomeMansione", header: "Mansione" },
    { field: "descrizioneMansione", header: "Descr. Mansione" },
    { field: "dal", header: "Dal" },
    { field: "al", header: "Al" },
    { field: "nomeAzienda", header: "Azienda" },
    { field: "descrizioneRuolo", header: "Descr. Ruolo" },
    { field: "conteggioEsperienza", header: "Mesi Esper." },

    {
      header: "Azioni",
      accessorKey: "azioni",
      Cell: ({ row }) => (
        <button
          className="outside-delete-btn"
          onClick={(e) => {
            e.stopPropagation();
            setSelectedEsperienzeId(row.original.idEsperienzaTrainer);
            setShowPopUp(true);
          }}
        >
          <i className="fa-solid fa-trash"></i> Elimina
        </button>
      ),
    },
  ];

  const handleRowClick = (esperienza) => {
    navigate(`/esperienze-lavorative/${esperienza.idEsperienzaTrainer}`, {
      state: { esperienza },
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";

    const isoDatePart = dateString.slice(0, 10);
    const [year, month, day] = isoDatePart.split("-");
    if (!year || !month || !day) return "";

    return `${day}.${month}.${year}`;
  };

  return (
    <div className="content-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <PopUp
        open={showPopUp}
        setOpen={setShowPopUp}
        header="Conferma Eliminazione"
        content="Sei sicuro di voler rimuovere questa esperienza lavorative?"
        deleteFunction={handleDelete}
      />

      <div className="page-header">
        <div className="page-title">Esperienze Lavorative</div>
        <div className="controls">
          <div className="add-btn">
            <button onClick={() => navigate("/aggiungi-esperienze-lavorative")}>
              + Nuova Esperienza
            </button>
          </div>
        </div>
      </div>

      <div className="page-content">
        {esperienze.length === 0 && !loading ? (
          <p>Nessuna esperienza lavorativa trovata.</p>
        ) : (
          <Table
            columns={columns}
            data={esperienze}
            onRowClick={handleRowClick}
            pagination={false}
          />
        )}
      </div>
    </div>
  );
};

export default EsperienzeLavorative;
